
import BaseModalComponent from "@/components/Shared/Modals/BaseModal/BaseModalComponent";
export default BaseModalComponent;
